// The map is in the path without its de_ prefix (/v5/utility_hub/mirage); other prefixes stay.
export const mapSlug = (map) => map.replace(/^de_/, '');
const PREFIXED = /^(de|cs|ar|aim|awp|dz|fy|gd)_/;
export const mapFromSlug = (slug) => (PREFIXED.test(slug) ? slug : `de_${slug}`);
export const utilityHubPath = (map) => `/v5/utility_hub/${mapSlug(map)}`;

// Older links carry the map as ?selected_map=de_mirage
export function redirectSelectedMap(to) {
  const { selected_map: map, ...query } = to.query;
  if (!map || to.params.map) return true;
  return {
    path: utilityHubPath(map), query, hash: to.hash, replace: true,
  };
}

// The sidebar path stays /v5/utility_hub (routes.js would otherwise add a placeholder of the same
// name, which replaces this route); the map is an optional child param, so the page stays mounted
// when the map changes.
export default {
  path: '/v5/utility_hub',
  children: [{
    path: ':map?',
    name: 'V5_utility_hub',
    component: () => import('./UtilityHubPage.vue'),
    beforeEnter: redirectSelectedMap,
  }],
};
